import { CALL_UPDATE_ACTION, ICallState, ICallUpdateAction, } from './types';

export class CallActions {

	public static update (
		call: Partial<ICallState>,
	): ICallUpdateAction {
		return {
			type: CALL_UPDATE_ACTION,
			call,
		}
	}

}
